import React, { memo, useState, useEffect } from "react";
import { RCCButton, RCCGrid } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import Title from "src/components/Title";
import ListCards from "src/components/ListCards";
import { v4 } from "uuid";
import { ICardIndicatorsComponent } from "./interface";
import CardIndicator from "./card";
import Container from "./styles";
import { IListIndicators } from "../interface";

const CardIndicators: React.FC<ICardIndicatorsComponent> = ({
	data,
	options,
	filterList,
	openValuesOfPeriodIndicator,
	defaultChecked
}) => {
	const {translate} = useTranslation();
	const startIndex = data[0].values.findIndex((dt) => dt.currentPeriod === dt.labelCode);
	const [indexOfValues, setIndexOfValues] = useState<number>(startIndex > -1 ? startIndex : 0);
	const [dataInternal, setDataInternal] = useState<IListIndicators[]>([]);
	const [actualPeriod, setActualPeriod] = useState("");

	const goPrev = () => {
		if(indexOfValues === 0)
			return;
		setIndexOfValues((prevState) => prevState - 1);
	};

	const goNext = () => {
		if(indexOfValues === data[0].values.length - 1)
			return;
		setIndexOfValues((prevState) => prevState + 1);
	};

	useEffect(() => {
		const updateData = data.map((dt) => ({
			...dt,
			values: [dt.values[indexOfValues]]
		}));
		setActualPeriod(data[0].values[indexOfValues] !== undefined ? ` - ${data[0].values[indexOfValues].label}` : "");
		setDataInternal(updateData);
	}, [indexOfValues, data]);

	return(
		<>
			<RCCGrid container item direction="column">
				<Container>
					<RCCButton 
						color="transparent"
						icon={{
							name: "arrowLeft",
							color: "var(--purple-lighter)",
							size: 32
						}}
						onClick={() => goPrev()}
					/>
					<Title size="md" color="purple">
						{translate("Tipo de período")}: {data[0].iqb003Descricao} {actualPeriod}
					</Title>
					<RCCButton 
						color="transparent"
						icon={{
							name: "arrowRight",
							color: "var(--purple-lighter)",
							size: 32
						}}
						onClick={() => goNext()}
					/>
				</Container>
				<ListCards 
					data={dataInternal}
					mapper={(indicator: any) => <CardIndicator 
						key={v4()} 
						data={indicator}
						options={options}
						openValuesOfPeriodIndicator={openValuesOfPeriodIndicator}
						defaultChecked={defaultChecked}
					/>}
					filter={filterList ? (indicator) => indicator.iqc001Nivel === filterList : undefined} 
					manuallyToggleShowMore
				/>
			</RCCGrid>
		</>
	);};

export default memo(CardIndicators);
